<template>
  <section class="locations">
    <div class="location" v-for="location in allLocations">
      <div
        class="row flex-column-reverse flex-lg-row align-items-center justify-content-between"
      >
        <div class="col-12 col-lg-7">
          <div class="location__map">
            <GMapMap
              :center="{ lat: 0, lng: 0 }"
              :zoom="0"
              class="h-100"
              :options="options"
              :mapPlaceholderImage="
                locations.searchLocation.contactDetails.mapPlaceholderImage
              "
            >
              <GMapKmlLayer :url="combineUrls(location.map)" />
            </GMapMap>
          </div>
        </div>

        <div class="col-12 col-lg-5">
          <div class="location__info">
            <div>
              <h2>{{ location.locationName }}</h2>
              <div
                class="location__content"
                v-if="location.content"
                v-html="location.content"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SearchLocation :searchLocation="locations.searchLocation" />
  </section>
</template>

<script>
import SearchLocation from "@/components/locations/SearchLocation.vue";

export default {
  components: { SearchLocation },
  props: {
    locations: {
      locationsList: Array,
      searchLocation: {
        title: String,
        searchTitle: String,
        input: {
          placeholder: String,
        },
        button: {
          text: String,
        },
        contactDetails: {
          disableHeader: Boolean,
          title: String,
          description: HTMLElement,
          locationIcon: String,
          label: String,
          button: {
            text: String,
            link: String,
          },
          iconsDescription: {
            screwDriver: String,
            service: String,
          },
          mapPlaceholderImage: String,
          map: {
            zoom: Number,
          },
        },
      },
    },
  },
  data() {
    return {
      options: {
        disableDefaultUI: true,
      },
    };
  },
  methods: {
    combineUrls(relativeUrl) {
      return new URL(relativeUrl, new URL(this.baseUrl)).href;
    },
  },
  computed: {
    baseUrl() {
      return window.location.origin;
    },
    allLocations() {
      return this.locations.locationsList.filter((l) => l.locationName);
    },
  },
};
</script>
